'use client'

import { cn } from '@dc-shared-web/lib'

interface SideBarNavProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode
}

export function SideBarNav({ children, className, ...props }: SideBarNavProps) {
  return (
    <nav
      className={cn(
        'tw-grid tw-grid-cols-1 tw-gap-2 tw-auto-rows-min tw-p-4 tw-bg-white tw-border-solid tw-border-r-2 tw-shadow-md tw-h-auto tw-w-[50px] tw-py-4 tw-px-1 md:tw-px-4 md:tw-w-[25%] md:tw-max-w-[260px] tw-shrink-0',
        className
      )}
      {...props}
    >
      {children}
    </nav>
  )
}
